var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-12"},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anmerkungen")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"remarks"}})])])])])
}]

export { render, staticRenderFns }